import React from 'react';
import { Tabs, TabsProps } from 'antd';

interface CustomTabsProps {
  items: TabsProps['items'];
  onChange?: TabsProps['onChange'];
  className?: string;
  defaultActiveKey?: string;
}

/**
 * Custom wrapper component for Ant Design Tabs
 *
 * @param items - Tab items configuration
 * @param onChange - Callback when active tab changes
 */
const CustomTabs: React.FC<CustomTabsProps> = ({
  items,
  onChange,
  className,
  defaultActiveKey = '0',
}) => {
  return (
    <div className={`zl-custom-tabs ${className || ''}`}>
      <Tabs
        defaultActiveKey={defaultActiveKey}
        items={items}
        onChange={onChange}
      />
    </div>
  );
};

export default CustomTabs;
